import React, { Component, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import Pagination from 'react-js-pagination';
import CardHead from './../CardHead';
import History from '../../scenes/History/History';
import './styles.scss';

const ListTable = props => {
  const [activePage, setActivePage] = useState(1)
  

  const handleChangePage = (e) => {
    setActivePage({ activePage: e });
  }

  const handleClickPagination = (e) => {
    console.log(e);
  }

  const buildListItems = (listItems, itemsPerPage) => {
    const to = itemsPerPage * activePage;
    const from = to - itemsPerPage;

    const history = useHistory()

    listItems = listItems.slice(from, to);
    listItems = listItems.map((item, key) => (
      <Link 
        key={item.bidSessionId} 
        style={{ textDecoration: 'none' }} 
        to={`/history/${item.bidSessionId}`} 
        onClick={() => history.push(`/history/${item.bidSessionId}`)} 
      >
        <CardHead
          key={item.bidSessionId}
          title={item.name}
          subtitle={item.subtitle}
          hasMenu={false}
          headClassName={key % 2 === 0 ? 'list-item bc-white' : 'list-item bc-trans'}
          rightIcon="ion-ios-arrow-right"
        />
      </Link>
    ));
    return listItems;
  }

    let { listItems } = props;
    const { itemsPerPage, pageRangeDisplayed } = props;

    if (listItems.constructor === Array) {
      listItems = buildListItems(listItems, itemsPerPage);
    }

    return (
      <div className="items-container large-12 columns">
        <div className="list">
          {listItems}
        </div>
        {listItems.length > itemsPerPage &&
          <div className="pagination-container large-12 columns">
            <Pagination
              activePage={activePage}
              itemsCountPerPage={itemsPerPage}
              totalItemsCount={listItems.length}
              pageRangeDisplayed={pageRangeDisplayed}
              onChange={() => handleChangePage()}
              onClick={() => handleClickPagination()}
              prevPageText={<i className="ion-ios-arrow-back arrow-pag" />}
              nextPageText={<i className="ion-ios-arrow-forward arrow-pag" />}
            />
          </div>
        }
      </div>
    );
  
}

ListTable.propTypes = {
  listItems: PropTypes.any.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  pageRangeDisplayed: PropTypes.number.isRequired,
};

export default ListTable;
